import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { fetchEditorialArticleById } from 'common/api/editorial';
import Spinner from 'components/Spinner';

const getBreadcrumbs = ({ series, categories }) =>
  [series[0], categories[0]].filter((item) => item);

const SpotTravelArticle = ({ articleId }) => {
  const [article, setArticle] = useState();

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const response = await fetchEditorialArticleById({
          id: articleId,
          geotarget: '',
          preview: null,
          cookies: null,
          isServer: false,
        });

        const articleIdStr = articleId?.toString();
        const articleIdAsNumber = +articleId;
        const idsMatch = response.id === articleIdAsNumber;
        const wordpressIdMatch = response.wordpressId === articleIdAsNumber;
        const feedIdMatch =
          articleIdStr && (response.id === articleIdStr || response.sys?.id === articleIdStr);

        if (idsMatch || wordpressIdMatch || feedIdMatch) {
          setArticle(response);
        }
      } catch (_error) {
        setArticle(undefined);
      }
    };
    fetchArticle();
  }, [articleId]);

  return (
    <article
      className={`
        sl-spot-travel-article
        ${!article ? 'sl-spot-travel-article--loading' : ''}
      `}
    >
      {!article ? (
        <Spinner />
      ) : (
        <>
          <figure className="sl-spot-travel-article__thumbnail">
            <div
              className="sl-spot-travel-article__thumbnail__img"
              alt={article.content.title}
              style={{
                backgroundImage: `url(${article.media.feed1x})`,
              }}
            />
          </figure>
          <div className="sl-spot-travel-article__details">
            <ul className="sl-spot-travel-article__details__breadcrumbs">
              {getBreadcrumbs(article).map(({ name, slug, url }) => (
                <li key={slug} className="sl-spot-travel-article__details__breadcrumb">
                  <a
                    className="sl-spot-travel-article__details__breadcrumb__link"
                    href={url}
                    title={name}
                  >
                    {name}
                  </a>
                </li>
              ))}
            </ul>
            <h3 className="sl-spot-travel-article__details__title">
              <a href={article.permalink} title={article.content.title}>
                {article.content.title}
              </a>
            </h3>
            <p className="sl-spot-travel-article__details__subtitle">{article.content.subtitle}</p>
            <a className="sl-spot-travel-article__details__link" href={article.permalink}>
              Read Article
            </a>
          </div>
        </>
      )}
    </article>
  );
};

SpotTravelArticle.propTypes = {
  articleId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default SpotTravelArticle;
